import { render, staticRenderFns } from "./news-tab.vue?vue&type=template&id=0c89dc5a"
import script from "./news-tab.vue?vue&type=script&lang=js"
export * from "./news-tab.vue?vue&type=script&lang=js"
import style0 from "./news-tab.vue?vue&type=style&index=0&id=0c89dc5a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports